import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import NavigationDrawerContent from 'Views/Onboarding/Components/NavigationDrawerContent';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import fr from 'facet-rest';
import Sentry from 'Integrations/Sentry';
import { useRefreshOnboardingNavigation } from 'Hooks/useRefreshEvent';
import useDrawerState from 'Hooks/useDrawerState';
import Button from 'Components/UI/Button';
import { useOnboardingHeaderContext } from 'Views/Onboarding/Contexts/OnboardingHeaderContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { pickFunction } from 'Helpers/Affordances';

const styles = theme => ({
  root: {},
  drawerPaper: {
    borderTopRightRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
    width: '90%',
    minWidth: 320,
    maxWidth: 500,
  },
});

const OnboardingNavigation = ({
  className,
  classes,
  clientResource,
}) => {
  const isMobile = useMobileLayout();
  const { loadOnboardingStepCollection } = useSurveyContext();
  const { isHeaderThemeDark } = useOnboardingHeaderContext();
  const [navigationResource, setNavigationResource] = React.useState(null);

  async function getNavigationData() {
    try {
      const [x] = await clientResource.relationship(fr.relationships.onboardingNavigation.name).link('related').get();
      setNavigationResource(x);
    } catch (err) {
      Sentry.createSentryErrorLog(err);
    }
  }

  useRefreshOnboardingNavigation(() => {
    getNavigationData();
  }, [clientResource]);

  React.useEffect(() => {
    getNavigationData();
  }, [clientResource]);

  const { open, toggleDrawer } = useDrawerState({
    onOpen: () => {
      getNavigationData();
    },
  });

  const menu = (
    <Button
      className={classNames(classes.root, className)}
      onClick={toggleDrawer}
      test="onboarding-menu-button"
      color={isHeaderThemeDark ? 'white' : 'primary'}
      variant={'icon'}
    >
      <MenuIcon />
    </Button>
  );

  const menuButton = pickFunction(clientResource, {
    [fr.relationships.onboardingNavbar.name]: () => {
      return isMobile ? menu : null;
    },
    [fr.relationships.default.name]: () => {
      return menu;
    },
  });

  return (
    <React.Fragment>
      {menuButton}
      <Drawer
        anchor="left"
        open={open}
        ModalProps={{ onBackdropClick: toggleDrawer }}
        PaperProps={{ className: classes.drawerPaper }}
      >
        <NavigationDrawerContent
          toggleDrawer={toggleDrawer}
          clientResource={clientResource}
          navigationResource={navigationResource}
          onCardClick={loadOnboardingStepCollection}
        />
      </Drawer>
    </React.Fragment>
  );
};

OnboardingNavigation.defaultProps = {
  className: '',
};

OnboardingNavigation.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  clientResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingNavigation);
